import type { MittwaldAPIV2Client } from "@mittwald/api-client-NEXT";
import { extractTotalCountHeader } from "@mittwald/api-client-NEXT";
import { assertStatus } from "@mittwald/api-client-NEXT";
import type { BackupBehaviors } from "./types.js";

export const apiBackupBehaviors = (
  client: MittwaldAPIV2Client,
): BackupBehaviors => ({
  find: async (projectBackupId) => {
    const response = await client.backup.getProjectBackup({ projectBackupId });
    if (response.status === 200) {
      return response.data;
    }
    assertStatus(response, 404);
  },

  list: async (projectId, query) => {
    const response = await client.backup.listProjectBackups({
      projectId,
      queryParameters: query,
    });
    assertStatus(response, 200);
    return {
      items: response.data,
      totalCount: extractTotalCountHeader(response),
    };
  },

  create: async (projectId, data) => {
    const response = await client.backup.createProjectBackup({
      projectId,
      data,
    });
    assertStatus(response, 201);
    return response.data;
  },

  delete: async (projectBackupId) => {
    const response = await client.backup.deleteProjectBackup({
      projectBackupId,
    });
    assertStatus(response, 204);
  },

  updateDescription: async (projectBackupId, description) => {
    const response = await client.backup.updateProjectBackupDescription({
      projectBackupId,
      data: { description },
    });
    assertStatus(response, 204);
  },

  createExport: async (projectBackupId, data) => {
    const response = await client.backup.createProjectBackupExport({
      projectBackupId,
      data,
    });
    assertStatus(response, 204);
  },
});
